import cn from 'classnames';
import {FC} from 'react';
import type {Bank} from '@rocket-ui/lk-api';
import {PAYMENT_BIK_NOT_FOUND_MESSAGE, SelectedBank} from '../../../model';
import {BankIcon} from './BankIcon';
import styles from './BankListPanel.module.css';

type Props = {
	banks: Bank[];
	isLoading: boolean;
	showNotFound: boolean;
	selectedBankId: number | null;
	onSelect?: (bank: SelectedBank) => void;
	/** Только инфо о банке, без выбора вручную */
	infoOnly?: boolean;
	className?: string;
};

export const BankInlineResults: FC<Props> = ({
	banks,
	isLoading,
	showNotFound,
	selectedBankId,
	onSelect,
	infoOnly = false,
	className,
}) => {
	if (isLoading) {
		return <p className={cn(styles.status, styles.statusFlush, className)}>Загрузка…</p>;
	}

	if (showNotFound) {
		return (
			<p className={cn(styles.status, styles.statusFlush, styles.statusError, className)}>
				{PAYMENT_BIK_NOT_FOUND_MESSAGE}
			</p>
		);
	}

	if (banks.length === 0) {
		return null;
	}

	if (infoOnly) {
		return (
			<ul className={cn(styles.panel, styles.panelFlush, className)} aria-label="Найденный банк">
				{banks.map((bank) => (
					<li key={bank.id} className={styles.infoRow}>
						<BankIcon bank={bank} className={styles.optionFlag} />
						<span className={styles.optionLabel}>{bank.shortName ?? bank.officialName}</span>
					</li>
				))}
			</ul>
		);
	}

	return (
		<ul className={cn(styles.panel, className)} role="listbox" aria-label="Результаты поиска банка">
			{banks.map((bank) => (
				<li key={bank.id} role="none">
					<button
						type="button"
						role="option"
						aria-selected={selectedBankId === bank.id}
						className={cn(styles.option, selectedBankId === bank.id && styles.optionSelected)}
						onClick={() =>
							onSelect?.({
								id: bank.id,
								bik: bank.bik ?? null,
								shortName: bank.shortName ?? null,
								iconUrl: bank.iconUrl ?? null,
							})
						}
					>
						<BankIcon bank={bank} className={styles.optionFlag} />
						<span className={styles.optionLabel}>{bank.shortName ?? bank.officialName}</span>
					</button>
				</li>
			))}
		</ul>
	);
};
